module.exports = __webpack_public_path__ + "static/media/art-logo-horizontal.78769b14.png";